module.exports = __webpack_public_path__ + "img/receipt29.70301b54.png";